/**
 * Chuỗi hiển thị của nhóm D (báo cáo MH-32, lĩnh vực cấp 2 MH-37, nhật ký MH-38,
 * thông tin cá nhân MH-40) khi dựng lại theo bản mẫu CMS "Thông tin nguồn".
 * Chuỗi cũ dùng lại từ `vi.ts`; tệp này chỉ chứa chuỗi MỚI.
 */
export const viQuanTri = {
  /* ------------------------------- MH-32 ---------------------------------- */
  baoCao: {
    loaiBaoCao: 'Loại báo cáo',
    /** Ba loại báo cáo của biểu mẫu Phụ lục 2 Công văn 276 (bản mẫu). */
    cacLoaiBaoCao: [
      'Số liệu hoạt động truyền thanh cấp xã',
      'Số liệu tập huấn, bồi dưỡng cán bộ cấp xã',
      'Số liệu về thông tin trực quan cấp xã',
    ],
    xuatBaoCao: 'Xuất báo cáo',
    nhapBaoCao: 'Nhập báo cáo',
    dangXuat: 'Đang xuất…',
    taiVe: 'Tải tệp về',
    xuatLoi: 'Xuất báo cáo thất bại',
    chonMotKyDeXuat: 'Chọn đúng một kỳ báo cáo trong bảng để xuất.',
    nhom: {
      donViHanhChinh: 'Đơn vị hành chính',
      quy: 'Quý',
      nam: 'Năm',
      quyTrinh: 'Quy trình',
    },
    loaiDonVi: { phuong: 'Phường', xa: 'Xã', dacKhu: 'Đặc khu' },
    tatCa: 'Tất cả',
    cot: {
      stt: 'STT',
      maDinhDanh: 'Mã định danh (QĐ số 20/2020/QĐ-TTg)',
      quy: 'Quý',
      nam: 'Năm',
      tenDonVi: 'Tên đơn vị hành chính',
      tongSoThon: 'Tổng số thôn, tổ dân phố',
      daiFm: 'Đài có dây/không dây FM',
      daiCntt: 'Đài ứng dụng CNTT',
      soCumLoa: 'Số cụm loa',
      soNguoi: 'Số người làm công tác truyền thanh',
      quyTrinh: 'Quy trình',
      donViHanhChinh: 'Đơn vị hành chính',
      thoiGianGui: 'Thời gian gửi báo cáo',
      trangThai: 'Trạng thái',
    },
    tab: { duyet: 'Duyệt báo cáo', trungUong: 'Gửi lên trung ương' },
    guiDuyet: 'Gửi duyệt',
    guiTrungUong: 'Gửi lên trung ương',
    xacNhanDuyetTieuDe: 'Duyệt (chốt) kỳ báo cáo',
    xacNhanDuyetHeQua:
      '{so} kỳ báo cáo đang nhập sẽ được chốt và chuyển sang chỉ đọc. Kỳ đã chốt hoặc đã gửi được bỏ qua.',
    daDuyet: 'Đã duyệt {so} kỳ báo cáo.',
    duyetMotPhan: 'Đã duyệt {thanhCong} kỳ, {thatBai} kỳ lỗi: {loi}',
    ghiChuAnhXa:
      'Mỗi dòng là một kỳ báo cáo của tỉnh (mô hình dữ liệu hiện có). Cột "Mã định danh" hiển thị mã báo cáo; "Tên đơn vị hành chính" là tỉnh của phiên đăng nhập. Số liệu từng chỉ tiêu xem trong chi tiết kỳ.',
    ghiChuDuyet:
      '"Gửi duyệt" chờ backend hiện thực API gửi duyệt kỳ báo cáo; không dùng API chốt kỳ vì chốt sẽ khoá số liệu.',
  },

  /* ------------------------------- MH-37 ---------------------------------- */
  linhVuc: {
    tieuDe: 'Quản lý lĩnh vực cấp 2',
    chonCap1: 'Chọn lĩnh vực cấp 1',
    locCap1: 'Lọc theo lĩnh vực cấp 1',
    themMoi: 'Thêm mới',
    nhapExcel: 'Nhập từ Excel',
    cot: {
      stt: 'STT',
      cap2: 'Lĩnh vực cấp 2',
      cap1: 'Lĩnh vực cấp 1',
      thoiGianTao: 'Thời gian tạo',
      nguoiTao: 'Người tạo',
    },
    cap1: 'Lĩnh vực cấp 1',
  },

  /* ------------------------------- MH-38 ---------------------------------- */
  nhatKy: {
    tieuDeChung: 'Nhật ký hệ thống',
    tuNgay: 'Ngày bắt đầu',
    denNgay: 'Ngày kết thúc',
    khoangNgay: 'Khoảng ngày',
    taiKhoan: 'Tài khoản',
    nhapTaiKhoan: 'Nhập tài khoản',
    timKiem: 'Tìm kiếm',
    loaiDoiTuongCauHinh: 'Nhóm cấu hình',
    cot: {
      stt: 'STT',
      thoiDiem: 'Thời điểm',
      tacNhan: 'Tác nhân',
      hanhDong: 'Hành động',
      ketQua: 'Kết quả',
      doiTuong: 'Đối tượng',
    },
    ketQua: { thanh_cong: 'Thành công', that_bai: 'Thất bại' },
    /** Tên dễ đọc của các mã thao tác backend đang ghi vào `nguoi_dung_nhat_ky`. */
    hanhDong: {
      dang_nhap: 'Đăng nhập',
      khoa_tai_khoan: 'Khoá tài khoản',
      mo_khoa_tai_khoan: 'Mở khoá tài khoản',
      doi_quyen_nhom: 'Đổi quyền nhóm',
      doi_ten_don_vi_hanh_chinh: 'Đổi tên đơn vị hành chính',
      sap_nhap_don_vi_hanh_chinh: 'Sáp nhập đơn vị hành chính',
      chia_tach_don_vi_hanh_chinh: 'Chia tách đơn vị hành chính',
      dat_cong_tac_dong_bo_tinh: 'Bật/tắt đồng bộ lên trung ương',
      chuyen_ngu_canh_tinh: 'Chuyển ngữ cảnh tỉnh',
      'adapter_service.create': 'Thêm service bộ tương thích',
      'adapter_service.update': 'Sửa service bộ tương thích',
      'adapter_service.delete': 'Xoá service bộ tương thích',
      'vendor_adapter.conformance_test': 'Kiểm thử tuân thủ bộ tương thích',
    } as Record<string, string>,
    loaiDoiTuong: {
      nguoi_dung: 'Người dùng',
      nhom_nguoi_dung: 'Nhóm quyền',
      don_vi_hanh_chinh: 'Đơn vị hành chính',
      tenant: 'Tỉnh (đa tỉnh)',
      adapter_service: 'Service bộ tương thích',
    } as Record<string, string>,
    ghiChuNhom: {
      'dieu-khien':
        'Backend chưa ghi lệnh điều khiển thiết bị vào nhật ký thao tác nên chưa lọc được nhóm này.',
      'dang-nhap': 'Lọc theo mã thao tác "dang_nhap" của nhật ký thao tác.',
      'trung-uong':
        'Hiện chỉ lọc được thao tác bật/tắt đồng bộ lên trung ương; lịch sử gói tin gửi đi xem ở màn hình hàng đợi kết nối trung ương.',
      'cau-hinh': 'API chỉ lọc được một loại đối tượng mỗi lần — chọn nhóm cấu hình cần xem.',
    },
  },

  /* ------------------------------- MH-40 ---------------------------------- */
  caNhan: {
    tieuDe: 'Thông tin cá nhân',
    anhDaiDien: 'Ảnh đại diện',
    tab: {
      thongTin: 'Thông tin cá nhân',
      googleAuth: 'Google Authenticator',
      doiMatKhau: 'Đổi mật khẩu',
    },
    ten: 'Tên',
    dienThoai: 'Điện thoại',
    email: 'E-mail',
    diaChi: 'Địa chỉ',
    chinhSua: 'Chỉnh sửa',
    moTa2fa: 'Xác thực hai lớp bằng ứng dụng Google Authenticator.',
    matKhauHienTai: 'Mật khẩu hiện tại',
    matKhauMoi: 'Mật khẩu mới',
    nhapLaiMatKhau: 'Nhập lại mật khẩu mới',
    goiYMatKhau: 'Tối thiểu 12 ký tự, có chữ hoa, chữ thường, chữ số và ký tự đặc biệt.',
    capNhatMatKhau: 'Cập nhật mật khẩu',
    luu: 'Lưu',
    huy: 'Huỷ',
    dangLuu: 'Đang lưu…',
    goiYDienThoai: 'Chỉ gồm chữ số, dấu + và khoảng trắng; 8–15 chữ số.',
    goiYXoa: 'Để trống để xoá thông tin.',
    thieuHoTen: 'Họ tên không được để trống.',
    emailKhongHopLe: 'E-mail không đúng định dạng.',
    dienThoaiKhongHopLe: 'Số điện thoại chỉ gồm chữ số, dấu + và khoảng trắng, có 8–15 chữ số.',
    daLuuHoSo: 'Đã cập nhật thông tin cá nhân.',
    loiLuuHoSo: 'Không lưu được thông tin cá nhân',
    phienDangNhap: 'Phiên đăng nhập',
    cap: 'Cấp tài khoản',
    diaBan: 'Địa bàn',
    capNhan: { tinh: 'Cấp tỉnh', xa: 'Cấp xã' },
    toanTinh: 'Toàn tỉnh',
    dangGui: 'Đang cập nhật…',
    daDoiMatKhau: 'Đã đổi mật khẩu. Các phiên đăng nhập khác của bạn đã bị đăng xuất.',
    loiDoiMatKhau: 'Không đổi được mật khẩu',
  },

  /* -------------------- Độ mạnh mật khẩu (dùng chung) --------------------- */
  matKhau: {
    /** Khớp `matKhauDuManh` của máy chủ (packages/common/xac-thuc/mat-khau.ts). */
    tieuChi: {
      doDai: 'Ít nhất 12 ký tự',
      chuThuong: 'Có chữ thường (a–z)',
      chuHoa: 'Có chữ hoa (A–Z)',
      chuSo: 'Có chữ số (0–9)',
      kyTuDacBiet: 'Có ký tự đặc biệt (!@#…)',
    },
    doManh: 'Độ mạnh',
    muc: { rong: 'Chưa nhập', yeu: 'Yếu', trungBinh: 'Trung bình', manh: 'Mạnh' },
    datTieuChi: 'đạt',
    chuaDatTieuChi: 'chưa đạt',
    khongKhop: 'Mật khẩu nhập lại không khớp.',
    chuaDuManh: 'Mật khẩu mới chưa đủ mạnh — xem các tiêu chí bên dưới.',
    trungCu: 'Mật khẩu mới phải khác mật khẩu hiện tại.',
  },

  /* ----------------- Đăng nhập: đổi mật khẩu lần đầu, 2FA ----------------- */
  dangNhapThem: {
    doiMatKhauTieuDe: 'Đổi mật khẩu lần đầu',
    doiMatKhauMoTa:
      'Tài khoản của bạn đang dùng mật khẩu ban đầu do quản trị viên cấp. Hãy đặt mật khẩu mới để tiếp tục.',
    matKhauMoi: 'Mật khẩu mới',
    nhapLai: 'Nhập lại mật khẩu mới',
    nutDoi: 'Đổi mật khẩu và tiếp tục',
    dangXuLy: 'Đang xử lý...',
    phienHetHan: 'Phiên đổi mật khẩu đã hết hạn (10 phút). Vui lòng đăng nhập lại.',
    loiDoi: 'Không đổi được mật khẩu. Vui lòng thử lại.',
    quayLai: 'Quay lại đăng nhập',
    haiLopTieuDe: 'Xác thực hai lớp',
    haiLopMoTa: 'Nhập mã 6 số trong ứng dụng xác thực, hoặc một mã dự phòng.',
    maXacThuc: 'Mã xác thực',
    nutXacThuc: 'Xác thực',
    loiHaiLop: 'Mã xác thực không đúng hoặc phiên đã hết hạn.',
  },

  /* ------------------------------- MH-34 ---------------------------------- */
  nguoiDung: {
    cot: { cap: 'Cấp', diaBan: 'Địa bàn', dienThoai: 'Điện thoại' },
    cap: { tinh: 'Tỉnh', xa: 'Xã' },
    toanTinh: 'Toàn tỉnh',
    choDoiMatKhau: 'Chờ đổi mật khẩu',
    sua: 'Sửa',
    loc: {
      cap: 'Cấp',
      tatCaCap: 'Tất cả cấp',
      xa: 'Xã',
      tatCaXa: 'Tất cả xã',
      timXa: 'Tìm xã…',
      nhom: 'Nhóm quyền',
      tatCaNhom: 'Tất cả nhóm',
      trangThai: 'Trạng thái',
      tatCaTrangThai: 'Tất cả trạng thái',
      tuKhoa: 'Từ khoá',
      goiYTuKhoa: 'Tên đăng nhập, họ tên, email',
      tim: 'Tìm',
    },
    form: {
      tieuDeTao: 'Tạo tài khoản',
      tieuDeSua: 'Sửa tài khoản {ten}',
      tenDangNhap: 'Tên đăng nhập',
      hoTen: 'Họ tên',
      email: 'Email',
      dienThoai: 'Điện thoại',
      diaChi: 'Địa chỉ',
      cap: 'Cấp',
      capTinh: 'Cấp tỉnh (toàn tỉnh)',
      capXa: 'Cấp xã (quản lý đúng 1 xã)',
      xa: 'Xã quản lý',
      chonXa: '— Chọn xã —',
      timXa: 'Tìm xã…',
      nhom: 'Nhóm quyền',
      goiYNhomXa: 'Tài khoản cấp xã chỉ được gán các nhóm dùng được cho cấp xã.',
      khongCoNhom: 'Chưa có nhóm quyền phù hợp.',
      tao: 'Tạo tài khoản',
      luu: 'Lưu thay đổi',
      huy: 'Huỷ',
      dangLuu: 'Đang lưu…',
      thieuXa: 'Tài khoản cấp xã phải chọn đúng 1 xã.',
      thieuTruong: 'Nhập đủ tên đăng nhập và họ tên.',
      daSua: 'Đã cập nhật tài khoản {ten}.',
      dangTaiChiTiet: 'Đang tải thông tin tài khoản…',
    },
    matKhau: {
      tieuDeTao: 'Đã tạo tài khoản {ten}',
      tieuDeDatLai: 'Đã đặt lại mật khẩu cho {ten}',
      nhan: 'Mật khẩu ban đầu',
      canhBao: 'Mật khẩu chỉ hiển thị MỘT LẦN. Hãy sao chép và gửi cho người dùng qua kênh an toàn.',
      ghiChu: 'Người dùng phải đổi mật khẩu này khi đăng nhập lần đầu.',
      saoChep: 'Sao chép',
      daSaoChep: 'Đã sao chép',
      dong: 'Đã lưu, đóng',
    },
    xacNhanDatLai: 'Đặt lại mật khẩu cho {ten}? Mật khẩu hiện tại sẽ hết hiệu lực.',
    /** Diễn giải mã lỗi API (packages/common) thành câu dễ hiểu. */
    loi: {
      FORBIDDEN:
        'Bạn không có quyền thực hiện thao tác này, hoặc đang gán quyền vượt quá quyền của chính bạn.',
      OUT_OF_SCOPE_AREA: 'Địa bàn đã chọn nằm ngoài phạm vi cho phép.',
      INVALID_VALUE: 'Dữ liệu chưa hợp lệ.',
      MISSING_FIELD: 'Còn thiếu thông tin bắt buộc.',
      OPERATION_NOT_ALLOWED: 'Không thể tự khoá, tự đổi cấp, nhóm quyền hoặc phạm vi của chính mình.',
      /** Hợp đồng A0 đa tỉnh: tên đăng nhập duy nhất toàn hệ thống, không nêu tỉnh trùng. */
      DUPLICATE: 'Tên đăng nhập đã được sử dụng.',
      CONFLICT: 'Dữ liệu bị trùng hoặc đã thay đổi.',
      UNAUTHORIZED: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại.',
      RESOURCE_NOT_FOUND: 'Không tìm thấy tài khoản.',
      macDinh: 'Thao tác thất bại.',
    },
    chiTietLoi: 'Chi tiết: {chiTiet}',
  },

  /* ---------------------- Tài khoản xã — khung trang ---------------------- */
  taiKhoanXa: {
    diaBanCoDinh: 'Địa bàn được phân công (cố định)',
  },

  /* -------- Liên hệ từ trang giới thiệu — hợp đồng A0 liên hệ mục 5 -------- */
  lienHe: {
    tieuDe: 'Liên hệ',
    moTa: 'Yêu cầu tư vấn, hỗ trợ gửi từ form Liên hệ trên trang giới thiệu.',
    soMoi: '{so} liên hệ mới',
    nhanHuyHieu: '{so} liên hệ mới chưa xử lý',
    cot: {
      thoiGian: 'Thời gian',
      hoTen: 'Họ tên',
      coQuan: 'Cơ quan',
      dienThoai: 'Điện thoại',
      email: 'E-mail',
      diaPhuong: 'Tỉnh/thành',
      noiDung: 'Nội dung',
      trangThai: 'Trạng thái',
      hanhDong: 'Thao tác',
    },
    trangThai: { moi: 'Mới', dang_xu_ly: 'Đang xử lý', da_xu_ly: 'Đã xử lý' },
    loc: {
      trangThai: 'Trạng thái',
      tatCa: 'Tất cả trạng thái',
      tuKhoa: 'Từ khoá',
      goiYTuKhoa: 'Họ tên, cơ quan, điện thoại, e-mail, nội dung…',
      tim: 'Tìm',
    },
    xemDu: 'Xem đủ',
    xuLy: 'Xử lý',
    rongMoTa: 'Chưa có liên hệ nào được gửi từ trang giới thiệu.',
    hop: {
      tieuDe: 'Xử lý liên hệ',
      tieuDeXem: 'Nội dung liên hệ',
      nguoiGui: 'Người gửi',
      guiLuc: 'Gửi lúc',
      noiDung: 'Nội dung',
      trangThai: 'Trạng thái xử lý',
      ghiChu: 'Ghi chú xử lý',
      goiYGhiChu: 'Đã gọi lại, hẹn khảo sát…',
      nguoiXuLy: 'Người xử lý gần nhất: {ten} lúc {luc}',
      khongRoTen: '(không rõ tên)',
      luu: 'Lưu',
      dangLuu: 'Đang lưu…',
      dong: 'Đóng',
      huy: 'Huỷ',
      loiGhiChuDai: 'Ghi chú tối đa 1000 ký tự.',
    },
    daCapNhat: 'Đã cập nhật liên hệ của {ten}.',
    loi: {
      FORBIDDEN: 'Bạn không có quyền xử lý liên hệ.',
      RESOURCE_NOT_FOUND: 'Liên hệ không còn tồn tại.',
      INVALID_VALUE: 'Dữ liệu không hợp lệ.',
      MISSING_FIELD: 'Thiếu thông tin bắt buộc.',
      macDinh: 'Thao tác thất bại.',
    },
  },
} as const;
